import React, { useState } from 'react'
import styled from 'styled-components/macro'

import { Spinner } from '../../advanced/loader'
import { Block, Flex } from '../layout'
import PlaceholderImage from './placeholder.png'

const Figure = styled.figure`
	height: ${props => props.height};
	width: ${props => props.width};
	padding: ${props => props.padding ? props.padding : '0'};
	margin: ${props => props.margin ? props.margin : '0'};
	text-align: ${props => props.align && props.align};
	cursor: ${props => props.cursor && props.cursor};
`

const Img = styled.img`
	height: ${props => props.height};
	width: ${props => props.width};
`

export const ImageBlock = ({
	figureHeight,
	figureWidth,
	height,
	width,
	alt,
	ariaLabel,
	margin,
	padding,
	align,
	cursor,
	click,
	src,
	children
}) => {
	const [loading, setLoading] = useState(true)
	const [imageUrl, setImageUrl] = useState(src)
	const testImage = new Image()
	const ImageFound = () => {
		setLoading(false)
		setImageUrl(src)
	}
	const ImageNotFound = () => {
		setLoading(false)
		setImageUrl(PlaceholderImage)
	}
	testImage.onload = ImageFound
	testImage.onerror = ImageNotFound
	testImage.src = src

	const loadingBlock = (
		<Block height={height}>
			<Flex position="absolute" height="100%" top="0" background="rgba(0,0,0,.25)">
				<Spinner size="50px" thickness="5px" />
			</Flex>
			<Img
				onClick={click}
				height={height}
				width={width}
				src={PlaceholderImage}
				role='img'
				alt='placeholder-image'
				aria-label='placeholder-image'
			/>
		</Block>
	)

	const image = (
		<Img
			onClick={click}
			height={height}
			width={width}
			src={imageUrl}
			role='img'
			alt={alt}
			aria-label={ariaLabel}
		/>
	)

	return (
		<Figure
			padding={padding}
			height={figureHeight}
			width={figureWidth}
			margin={margin}
			align={align}
			cursor={cursor}
		>
			{loading ? loadingBlock : image}
			{children}
		</Figure>
	)
}
